<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col :md="6" :sm="24">
              <a-form-item label="领用人昵称" prop="nickName">
                <a-input v-model="queryParam.nickName" :maxLength="32" placeholder="请输入领用人昵称" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="领用人手机号" prop="mobile">
                <a-input v-model="queryParam.mobile" :maxLength="32" placeholder="请输入领用人手机号" allow-clear/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="商品名称" prop="goodsName">
                <a-input v-model="queryParam.goodsName" :maxLength="32" placeholder="请输入商品名称" allow-clear/>
              </a-form-item>
            </a-col>
<!--            <a-col :md="6" :sm="24">
              <a-form-item :label="$t('优惠券自动发放-用户.店铺ID')" prop="shopId">
                <a-input v-model="queryParam.shopId" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.店铺ID')" allow-clear/>
              </a-form-item>
            </a-col>-->
            <template v-if="advanced">
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('优惠券自动发放-用户.商品id')" prop="goodId">
                  <a-input v-model="queryParam.goodId" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.商品id')" allow-clear/>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('优惠券自动发放-用户.面额')" prop="money">
                  <a-input v-model="queryParam.money" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.面额')" allow-clear/>
                </a-form-item>
              </a-col>
<!--              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('优惠券自动发放-用户.优惠券使用状态 1未使用；2已使用')" prop="usstate">
                  <a-input v-model="queryParam.usstate" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.优惠券使用状态 1未使用；2已使用')" allow-clear/>
                </a-form-item>
              </a-col>-->
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('优惠券自动发放-用户.优惠券使用状态 1未使用；2已使用')" prop="usstate">
                  <a-select :placeholder="$t('通用.输入.请选择')+$t('商品.商品状态')" style="width: 100%" v-model="queryParam.usstate" allowClear>
                    <a-select-option v-for="(item, index) in customDict.CouponAutoUseStateEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('优惠券自动发放-用户.优惠券状态 1正常；2作废')" prop="state">
                  <a-select :placeholder="$t('通用.输入.请选择')+$t('优惠券自动发放-用户.优惠券状态 1正常；2作废')" style="width: 100%" v-model="queryParam.state" allowClear>
                    <a-select-option v-for="(item, index) in customDict.CouponAutoEnum" :value="item.type" :key="index">
                      {{ item.name }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
<!--              <a-col :md="6" :sm="24">
                <a-form-item :label="$t('优惠券自动发放-用户.优惠券状态 1正常；2作废')" prop="state">
                  <a-input v-model="queryParam.state" :maxLength="32" :placeholder="$t('通用.输入.请输入')+$t('优惠券自动发放-用户.优惠券状态 1正常；2作废')" allow-clear/>
                </a-form-item>
              </a-col>-->
            </template>
            <a-col :md="!advanced && 6 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="handleQuery"><a-icon type="search" />{{$t('通用.按钮.查询')}}</a-button>
                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />{{$t('通用.按钮.重置')}}</a-button>
                <a @click="toggleAdvanced" style="margin-left: 8px">
                  {{ advanced ? $t('通用.按钮.收起') : $t('通用.按钮.展开') }}
                  <a-icon :type="advanced ? 'up' : 'down'"/>
                </a>
              </span>
            </a-col>
          </a-row>
        </a-form>
        <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
          <img alt="example" style="width: 100%" :src="previewUrl" />
        </a-modal>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button type="primary" @click="$refs.createForm.handleAdd()" v-hasPermi="['coupon:couponauto:add']">
          <a-icon type="plus" />发放
        </a-button>
        <a-button type="primary" :disabled="single" @click="$refs.createForm.handleUpdate(undefined, ids)" v-hasPermi="['coupon:couponauto:edit']">
          <a-icon type="edit" />{{$t('通用.按钮.修改')}}
        </a-button>
<!--        <a-button type="danger" :disabled="multiple" @click="handleDelete" v-hasPermi="['coupon:couponauto:remove']">
          <a-icon type="delete" />{{$t('通用.按钮.删除')}}
        </a-button>
        <a-button type="primary" @click="handleExport" v-hasPermi="['coupon:couponauto:export']">
          <a-icon type="download" />{{$t('通用.按钮.导出')}}
        </a-button>-->
        <table-setting
          :style="{float: 'right'}"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        @change="handleSortChange"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
      >
        <span slot="useTime" slot-scope="text, record">
          {{ parseTime(record.useTime) }}
        </span>
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <span slot="usstate" slot-scope="text, record">
           <custom-dict-tag :options="customDict.CouponAutoUseStateEnum" :value="record.usstate"/>
        </span>
        <span slot="state" slot-scope="text, record">
           <custom-dict-tag :options="customDict.CouponAutoEnum" :value="record.state"/>
        </span>

        <span slot="operation" slot-scope="text, record">
          <a-divider type="vertical" v-hasPermi="['coupon:couponauto:edit']" />
          <a @click="$refs.createForm.handleUpdate(record, undefined)" v-hasPermi="['coupon:couponauto:edit']">
             <a-icon type="edit" />{{$t('通用.按钮.修改')}}
          </a>
          <a-divider type="vertical" v-hasPermi="['coupon:couponauto:remove']" />
<!--          <a @click="handleDelete(record)" v-hasPermi="['coupon:coupon/auto:remove']">
            <a-icon type="delete" />{{$t('通用.按钮.删除')}}
          </a>-->
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :pageSizeOptions="pageSizeOptions"
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => getTotal(total)"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageCouponAuto,listCouponAuto, delCouponAuto } from '@/api/coupon/couponAuto'
import CustomDictTag from "@/components/DictCustomTag";
import {mapGetters} from 'vuex'
import moment from 'moment';
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'

export default {
  name: 'CouponAuto',
  components: {
    CustomDictTag,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      pageSizeOptions: ['10', '20', '50', '100'],
      filteredInfo: {},
      sortedInfo : {},
      selectedRowKeys: [],
      selectedRows: [],
      //预览封面
      previewImageVisible: false,
      previewUrl: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 查询参数
      queryParam: {
        userId: undefined,
        shopId: undefined,
        goodId: undefined,
        useOrderId: undefined,
        useItemId: undefined,
        money: undefined,
        unit: undefined,
        count: undefined,
        detailMessage: undefined,
        usstate: undefined,
        startTime: undefined,
        endTime: undefined,
        useTime: undefined,
        state: undefined,
        pageNum: 1,
        pageSize: 10
      },
      columns: [
        /*{
          title: this.$t('优惠券自动发放-用户.主键id'),
          dataIndex: 'id',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: "领用人昵称",
          dataIndex: 'nickName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: "领用人手机号",
          dataIndex: 'mobile',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('优惠券自动发放-用户.店铺ID'),
          dataIndex: 'shopId',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('优惠券自动发放-用户.商品id'),
          dataIndex: 'goodId',
          width: 200,
          ellipsis: true,
          align: 'center'
        },
        {
          title: "商品名称",
          dataIndex: 'goodsName',
          width: 100,
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('优惠券自动发放-用户.优惠券使用订单id'),
          dataIndex: 'useOrderId',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('优惠券自动发放-用户.优惠券使用商品子订单id'),
          dataIndex: 'useItemId',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('优惠券自动发放-用户.面额'),
          dataIndex: 'money',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('优惠券自动发放-用户.优惠券状态 1正常；2作废'),
          dataIndex: 'state',
          scopedSlots: { customRender: 'state' },
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('优惠券自动发放-用户.一个单位发放面额'),
          dataIndex: 'unit',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: this.$t('优惠券自动发放-用户.单位数量'),
          dataIndex: 'count',
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('优惠券自动发放-用户.优惠券详细信息'),
          dataIndex: 'detailMessage',
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('优惠券自动发放-用户.优惠券使用状态 1未使用；2已使用'),
          dataIndex: 'usstate',
          scopedSlots: { customRender: 'usstate' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('优惠券自动发放-用户.有效期开始时间'),
          dataIndex: 'startTime',
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('优惠券自动发放-用户.有效期结束时间'),
          dataIndex: 'endTime',
          ellipsis: true,
          align: 'center'
        },*/
        /*{
          title: this.$t('优惠券自动发放-用户.使用时间'),
          dataIndex: 'useTime',
          scopedSlots: { customRender: 'useTime' },
          ellipsis: true,
          align: 'center'
        },*/
        {
          title: this.$t('优惠券自动发放-用户.创建时间'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center'
        },
        /*{
          title: this.$t('优惠券自动发放-用户.备注'),
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },*/

        {
          title: this.$t('通用.文本.操作'),
          dataIndex: 'operation',
          width: '18%',
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {
  },
  created () {
    this.getList()
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  methods: {
    moment,
    getTotal(total) {
      return this.$t('通用.文本.共')+total+this.$t('通用.文本.条')
    },
    /** 查询优惠券自动发放-用户列表 */
    getList () {
      this.loading = true
     pageCouponAuto(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },

    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        userId: undefined,
        shopId: undefined,
        goodId: undefined,
        useOrderId: undefined,
        useItemId: undefined,
        money: undefined,
        unit: undefined,
        count: undefined,
        detailMessage: undefined,
        usstate: undefined,
        startTime: undefined,
        endTime: undefined,
        useTime: undefined,
        state: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    handleSortChange(pagination, filters, sorter) {
      this.filteredInfo = filters
      this.sortedInfo = sorter
      if (sorter.order) {
        /** 排序字段 sortField **/
        /** 排序方式  sortOrder**/
        this.queryParam.sortField = sorter.columnKey
        if (this.queryParam.sortField==='createTime') {
          this.queryParam.sortField= 'id'
        }
        this.queryParam.sortOrder = sorter.order === 'ascend' ? 'asc' : 'desc'
        this.getList()
      } else {
        this.queryParam.sortField = '';
        this.queryParam.sortOrder = ''
        this.getList()
      }
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    handleRecordPreview(url) {
      this.previewUrl = url
      this.previewImageVisible = true
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids = []
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('通用.文本.确认删除所选中数据'),
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delCouponAuto(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              const message = that.$t('通用.文本.删除成功')
              that.$message.success(
                message,
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('通用.文本.是否确认导出'),
        content: this.$t('通用.文本.此操作将导出当前条件下所有数据而非选中数据'),
        onOk () {
          that.download('coupon/coupon/auto/export',
            ...that.queryParam
          , `优惠券自动发放-用户_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    }
  }
}
</script>
